module.exports = __webpack_public_path__ + "img/r-cb6-y1.b23bdd5d.gif";